import Vue from 'vue'
// import vueMoment from 'vue-moment'
import moment from 'moment'

// plugin to convert values (y,m,d) to a moment date object

export default {
  install(Vue, options) {
    // Add a global method
    Vue.prototype.$dateFromVal = function (y=null, m=null, d=null) {
      return moment().year(y || moment().year()).month((m || moment().month() + 1) - 1).date(d || 1)
    }
  }
}
